// extracted by mini-css-extract-plugin
module.exports = {"radioGroup":"_1M_iK","option":"_2o3xK"};